import {
	Label,
	Stack,
	Link as FluentLink,
	useTheme,
	FontIcon,
} from '@fluentui/react';
import React, {FC} from 'react';
import {useTranslation} from 'react-i18next';

export const FaqAttachment: FC<{elem: any}> = ({elem}) => {
	const {t} = useTranslation('common/faq');
	const theme = useTheme();
	return (
		<>
			{' '}
			{elem.attachments.length ? (
				<Label
					style={{
						paddingLeft: '10px',
					}}
				>
					{t('Attachments') + ':'}
				</Label>
			) : (
				<Label
					style={{
						paddingLeft: '10px',
						backgroundColor: theme.palette.neutralLight,
						padding: '10px',
						cursor: 'pointer',
						color: theme.palette.red,
					}}
				>
					{t('NoAttachments')}
				</Label>
			)}
			{elem.attachments?.map((attachment: any, i: number) => (
				<Stack
					key={i}
					tokens={{childrenGap: 6}}
					style={{
						marginBottom: '5px',
						paddingLeft: '10px',
						wordBreak: 'break-all',
						whiteSpace: 'break-spaces',
						maxWidth: 'calc(100% - 34px)',
					}}
				>
					<FluentLink
						target='_blank'
						download={false}
						href={
							attachment.file.originalFileName
								? `${attachment.file.uri}/${attachment.file.originalFileName}`
								: `${attachment.file.uri}`
						}
					>
						<FontIcon iconName='Attach' />
						{attachment.file.originalFileName ?? attachment.attachmentId}
					</FluentLink>
					{attachment.category && (
						<Stack.Item>{`(${attachment.category?.name})`}</Stack.Item>
					)}
				</Stack>
			))}
		</>
	);
};
